import axios from "axios";
import { API_BASE_URL } from "../../../config";


export const getBusinessProfileData = async (businessUserId) =>
{
    try
    {
        const response = await axios.get(`${API_BASE_URL}/api/BusinessProfile/getBusinessProfileForMessage`, {
            params: {
                businessUserId,
            },
        });
        console.log("biz profile: ", response.data);
        return response.data;
    } catch (error)
    {
        console.error("Error fetching getActiveConverstionList:", error);
        throw error;
    }
};
